import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import { PageDecorated } from 'pages/page';
import { urlSavedVideosSortingSelector, urlVideoIdSelector } from 'pages/channel.page';
import { useTranslation } from 'react-i18next';
import { VideoBoxDecorated } from 'components/video-box';
import { videoBoxRequestAction } from 'components/video-box/actions';
import { VideoControlsMenu } from 'pages/saved-videos.page/fragments/video-controls-menu';
import { isIframe } from 'integration/integration.utils';
import { Header } from 'components/header';
import { ContentBox } from 'components/content-box';
import { VideoCollection } from 'components/video-collection';
import { requestSavedVideosCollectionAction, requestSavedVideosMobileCollectionAction } from 'pages/saved-videos.page';
import { VideoListDecorated } from 'components/video-list';
import { ErrorEmptyChannel } from 'components/error-handle/errors/error-empty-channel';
import {
  collectionCurrentPageSelector,
  collectionSelector,
  collectionVideosSelector,
  getCurrentPageNumberSelector,
  getSavedVideosFeatureSelector,
  getVideosPerPageSelector,
  integrationSelector,
  userIdSelector,
  websiteSelector,
} from 'common/selectors';
import { SORTING_KEYS } from 'utils/enums';
import { Error404Page } from 'pages/error.pages';
import { VideoContextMenuDecorated } from 'components/video-context-menu';

const BASE_URL = '/saved-videos';
const SORT_BY = [SORTING_KEYS.recently_added, SORTING_KEYS.display_date, SORTING_KEYS.title_asc, SORTING_KEYS.plays];

const SavedVideosPageComponent = (props) => {
  const { t } = useTranslation();
  if (!props.withSavedVideos) {
    return <Error404Page />;
  }
  return (
    <PageDecorated className="ct-saved-videos-page">
      {props.videoId && (
        <VideoBoxDecorated
          playerConfiguration={props.website.playerConfiguration}
          videoBoxRequestAction={videoBoxRequestAction(props.videoId)}
          withRelatedVideos={false}
          inlineVideoControls={VideoControlsMenu}
        />
      )}

      <div>
        {isIframe(props.integration) && <Header />}

        <ContentBox>
          <h1 className="title">{t('saved_uploads')}</h1>

          {props.collection && props.collection.totalCount === 0 && !props.collection.isLoading && (
            <ErrorEmptyChannel errorMsg="no_savedvideos_message" />
          )}

          {/* FIXME - Until issue with vmpro sorting is resolved withSort = false, after that this prop can be
          removed if not needed anymore */}
          <VideoCollection
            withSort={true}
            baseUrl={BASE_URL}
            sortBy={SORT_BY}
            loadCollectionAction={requestSavedVideosCollectionAction(
              props.userId,
              props.perPage,
              props.pageNumber,
              props.sort
            )}
            loadMoreAction={requestSavedVideosMobileCollectionAction(
              props.userId,
              props.perPage,
              props.collectionPage,
              props.collectionVideos,
              props.sort
            )}
          >
            <VideoListDecorated baseUrl={BASE_URL} contextMenu={VideoContextMenuDecorated} />
          </VideoCollection>
        </ContentBox>
      </div>
    </PageDecorated>
  );
};

export const SavedVideosPage = withRouter(
  connect((state, props) => ({
    videoId: urlVideoIdSelector(state, props.match),
    website: websiteSelector(state),
    collectionPage: collectionCurrentPageSelector(state),
    collectionVideos: collectionVideosSelector(state),
    integration: integrationSelector(state),
    pageNumber: getCurrentPageNumberSelector(state, props.match),
    sort: urlSavedVideosSortingSelector(state, props.match),
    userId: userIdSelector(state),
    perPage: getVideosPerPageSelector(state),
    collection: collectionSelector(state),
    withSavedVideos: getSavedVideosFeatureSelector(state),
  }))(SavedVideosPageComponent)
);

export * from './effects';
export * from './actions';
export * from './saga';
export * from './reducer';
export * from './selectors';
